import { dataFetchingClient } from '../../utils/DataFetchingClient';
import { registerMutation, registerQuery, useMutation, useQuery } from 'academy-common-lib/utils/DataFetchingClient';
import http from 'hub-http/clients/apiClient';
import { BASE_URI_PROGRESS } from '../../constants/ApiConstants';
import { WatchLaterLearningContentTypeMap } from './favoritesTypes';
import { useLatestSavedItemsInteractions } from '../savedItems/savedItemsQueries';
import UsageTracker from '../../utils/UsageTracker';
export const BOOKMARKS_API_URL = `${BASE_URI_PROGRESS}/bookmarks`;
export const getBookmarkTrackUrl = id => `${BOOKMARKS_API_URL}/${id}/track`;
export const getBookmarkLessonUrl = id => `${BOOKMARKS_API_URL}/${id}/lesson`;
const FETCH_FAVORITES = registerQuery({
  fieldName: 'favorites',
  args: [],
  fetcher() {
    return http.get(BOOKMARKS_API_URL);
  }
});
export const getFavorites = () => {
  return dataFetchingClient.queryUnwrapped({
    query: FETCH_FAVORITES
  });
};
export const useWatchLater = ({
  skip = false
} = {}) => {
  const {
    data: watchLaterResponse,
    loading: watchLaterLoading,
    error: watchLaterError
  } = useQuery(FETCH_FAVORITES, {
    skip
  });
  return {
    watchLaterItems: watchLaterResponse ? watchLaterResponse.bookmarks : null,
    watchLaterLoading,
    watchLaterError
  };
};
export const SET_TRACK_FAVORITE = registerMutation({
  fieldName: 'setTrackFavorite',
  args: ['trackId'],
  fetcher({
    trackId
  }) {
    return http.post(getBookmarkTrackUrl(trackId));
  }
});
export const setTrackFavorite = trackId => {
  return dataFetchingClient.mutate({
    mutation: SET_TRACK_FAVORITE,
    refetchQueries: [FETCH_FAVORITES],
    variables: {
      trackId
    },
    update() {
      useLatestSavedItemsInteractions.getState().setLatestInteraction({
        itemId: Number(trackId),
        type: 'TRACK',
        action: 'ADD_TO_WATCH_LATER'
      });
    }
  });
};
export const DELETE_TRACK_FAVORITE = registerMutation({
  fieldName: 'deleteTrackFavorite',
  args: ['trackId'],
  fetcher({
    trackId
  }) {
    return http.delete(getBookmarkTrackUrl(trackId));
  }
});
export const deleteTrackFavorite = trackId => {
  return dataFetchingClient.mutate({
    mutation: DELETE_TRACK_FAVORITE,
    variables: {
      trackId
    },
    refetchQueries: [FETCH_FAVORITES],
    update() {
      useLatestSavedItemsInteractions.getState().setLatestInteraction({
        itemId: Number(trackId),
        type: 'TRACK',
        action: 'REMOVE_FROM_WATCH_LATER'
      });
    }
  });
};
export const SET_LESSON_FAVORITE = registerMutation({
  fieldName: 'setLessonFavorite',
  args: ['lessonId'],
  fetcher({
    lessonId
  }) {
    return http.post(getBookmarkLessonUrl(lessonId));
  }
});
export const setLessonFavorite = lessonId => {
  return dataFetchingClient.mutate({
    mutation: SET_LESSON_FAVORITE,
    variables: {
      lessonId
    },
    refetchQueries: [FETCH_FAVORITES],
    update() {
      useLatestSavedItemsInteractions.getState().setLatestInteraction({
        itemId: Number(lessonId),
        type: 'LESSON',
        action: 'ADD_TO_WATCH_LATER'
      });
    }
  });
};
export const DELETE_LESSON_FAVORITE = registerMutation({
  fieldName: 'deleteLessonFavorite',
  args: ['lessonId'],
  fetcher({
    lessonId
  }) {
    return http.delete(getBookmarkLessonUrl(lessonId));
  }
});
export const deleteLessonFavorite = lessonId => {
  return dataFetchingClient.mutate({
    mutation: DELETE_LESSON_FAVORITE,
    variables: {
      lessonId
    },
    refetchQueries: [FETCH_FAVORITES],
    update() {
      useLatestSavedItemsInteractions.getState().setLatestInteraction({
        itemId: Number(lessonId),
        type: 'LESSON',
        action: 'REMOVE_FROM_WATCH_LATER'
      });
    }
  });
};
const ADD_TO_WATCH_LATER = registerMutation({
  fieldName: 'AddToWatchLater',
  args: ['itemId', 'type'],
  fetcher: ({
    itemId,
    type
  }) => http.post(`${BOOKMARKS_API_URL}/${itemId}/${WatchLaterLearningContentTypeMap[type]}`)
});
export const useAddToWatchLater = ({
  id: itemId,
  type,
  language
}) => {
  const [mutate, {
    loading: addToWatchLaterLoading,
    called: addToWatchLaterCalled,
    error: addToWatchLaterError
  }] = useMutation(ADD_TO_WATCH_LATER, {
    variables: {
      itemId,
      type
    },
    refetchQueries: [{
      query: FETCH_FAVORITES
    }],
    onCompleted: () => {
      UsageTracker.track('interaction', {
        action: 'favorite-added',
        contentId: itemId.toString()
      });
    },
    update() {
      useLatestSavedItemsInteractions.getState().setLatestInteraction({
        itemId,
        type,
        action: 'ADD_TO_WATCH_LATER',
        language
      });
    }
  });
  return [mutate, {
    addToWatchLaterLoading,
    addToWatchLaterCalled,
    addToWatchLaterError
  }];
};
const REMOVE_FROM_WATCH_LATER = registerMutation({
  fieldName: 'removeFromWatchLater',
  args: ['itemId', 'type'],
  fetcher: ({
    itemId,
    type
  }) => http.delete(`${BOOKMARKS_API_URL}/${itemId}/${WatchLaterLearningContentTypeMap[type]}`)
});
export const useRemoveFromWatchLater = ({
  id: itemId,
  type,
  language
}) => {
  const [mutate, {
    loading: removeFromWatchLaterLoading,
    called: removeFromWatchLaterCalled,
    error: removeFromWatchLaterError
  }] = useMutation(REMOVE_FROM_WATCH_LATER, {
    variables: {
      itemId,
      type
    },
    refetchQueries: [{
      query: FETCH_FAVORITES
    }],
    onCompleted: () => {
      UsageTracker.track('interaction', {
        action: 'favorite-removed',
        contentId: itemId.toString()
      });
    },
    update() {
      useLatestSavedItemsInteractions.getState().setLatestInteraction({
        itemId,
        type,
        action: 'REMOVE_FROM_WATCH_LATER',
        language
      });
    }
  });
  return [mutate, {
    removeFromWatchLaterLoading,
    removeFromWatchLaterCalled,
    removeFromWatchLaterError
  }];
};